export default __webpack_public_path__ + "static/media/scale.fae68f92.svg";